import { useCallback } from 'react'
import set from 'lodash/set'
import { QueryKey, useQueryClient } from 'react-query'

export function useUpdateQuery<TData = any>(cacheKey: QueryKey) {
  const queryClient = useQueryClient()
  return useCallback(
    (data: TData, updatePath?: string) =>
      queryClient.setQueryData<TData>(cacheKey, (oldUser: any) =>
        updatePath ? set(oldUser, updatePath, data) : data,
      ),
    [cacheKey, queryClient],
  )
}
